module.exports = __webpack_public_path__ + "static/media/marutoku_plus_footer_banner.4a347973.png";